import { AlertCircle, Info, CheckCircle2 } from "lucide-react";

const VARIANTS = {
  error: { icon: AlertCircle, cls: "border-destructive/30 bg-destructive/5 text-destructive" },
  info: { icon: Info, cls: "border-gold/30 bg-gold/5 text-foreground" },
  success: { icon: CheckCircle2, cls: "border-emerald-700/25 bg-emerald-700/5 text-emerald-900" },
};

export function StatusBanner({ variant = "error", children, testId = "error-alert-banner" }) {
  const { icon: Icon, cls } = VARIANTS[variant];
  return (
    <div role={variant === "error" ? "alert" : "status"} data-testid={testId} className={`mw-fade flex items-start gap-3 rounded-md border px-4 py-3 text-sm ${cls}`}>
      <Icon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
      <div className="leading-relaxed">{children}</div>
    </div>
  );
}
